import { jsx as _jsx } from "react/jsx-runtime";
import { Slider as HeroSlider } from '@heroui/react';
export const Slider = (props) => {
    return _jsx(HeroSlider, { ...props });
};
export default Slider;
//# sourceMappingURL=Slider.js.map